"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("line-chart-element", {
    attrs: {
      "chart-id": _vm.chartId,
      "chart-options": _vm.chartOptions,
      "chart-data": _vm.chartData,
      width: _vm.width,
      height: _vm.height
    }
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;